<template>
  <div class="bg-black md:bg-opacity-0 bg-opacity-70">
      <h2 class="text-4xl text-gray-100 mb-6 font-semibold">{{timeline.title}}</h2>
      <transition-group name="fadeLeft">
        <vue-timeline-update v-for="e in experience" :key="e.id"
            :date="setDate(e.year, e.month)"
            :title="e.title"
            :color="e.cardColor"
            :thumbnail="e.logo"
            :category="e.category"
            :icon="e.icon"
            :description="setDescription(e)"
        ></vue-timeline-update>
      </transition-group>
    <!-- <div
        class="flex flex-col md:grid grid-cols-9 mx-auto p-2 text-blue-50"
    >
        <div :class="{'flex md:contents':true, 'flex-row-reverse':e.direction == 'left'}" v-for="e in experience" :key="e.id">
            <transition name="zoomLeft">
                <time-line-item 
                    v-if="e.direction == 'left' && e.show"
                    :title="e.title"
                    :description="e.description"
                    :year="e.year"
                    :time="e.time"
                    :card-classes="'col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto shadow-md '.concat(`bg-${e.cardColor}-100 dark:bg-${e.cardColor}-600`)"
                />
            </transition>
            <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
                <div class="h-full w-6 flex items-center justify-center">
                    <div class="h-full w-1 bg-blueGray-300 pointer-events-none"></div>
                </div>
                <div
                    class="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-blueGray-300 text-blueGray-600 dark:text-gray-800 shadow"
                >
                    <transition name="zoom">
                        <b v-if="e.show">{{ e.id }}</b>
                    </transition>
                </div>
            </div>
            <transition name="zoomRight">
                <time-line-item 
                    v-if="e.direction == 'right' && e.show"
                    :title="e.title"
                    :description="e.description"
                    :year="e.year"
                    :time="e.time"
                    :card-classes="'col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto shadow-md '.concat(`bg-${e.cardColor}-100 dark:bg-${e.cardColor}-600`)"
                />
            </transition>
        </div>
    </div> -->
  </div>
</template>

<script>
// import TimeLineItem from '@/components/timelineItem.vue'
export default {
    name: 'Timeline',
    components: {
        // TimeLineItem
    },
    computed: {
        timeline() {
            return this.$store.state.timeline
        }
    },
    data: () => ({
        experience: []
    }),
    async mounted() {
        const items = this.timeline.items
        const delay = ms => new Promise(res => setTimeout(res, ms));
        await delay(250)
        for (var item in items) {
            this.experience.push(items[item])
            await delay(500)
        }
    },
    methods: {
        setDate(year, month) {
            let date = new Date()
            date.setMonth(month - 1)
            date.setFullYear(year)
            return date
        },
        setDescription(item) {
            return `<h3><b><a href="${item.link}" target="_blank">${item.name}</a></b> - <small>${item.direction}</small><h3>
            <p>${item.description}</p><p class="text-${item.cardColor}-500">| ${item.year} - ${item.time} |</p>`
        }
    }
}
</script>

<style>

</style>